module.exports = {"loadingTime":2,"targetName":"display2.euronics","videoThumbnailLength":5}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 112
// module chunks = 0